/*
	CSS
*/
require('../css/bootstrap.min.css');
require('../css/font-awesome.min.css');
require('../css/dripicons.min.css');
require('../css/animate/animate.css');
require('../css/hover/hover-min.css');
require('../less/styles.less');
require('../../shared/css/blocks.css');
require('../css/modal-lightbox/ekko-lightbox.min.css');
require('../css/overlay-effects/overlay-effects.css');

/*
	scripts (as conventional globals)
*/
require("script!../js/vendors/jquery/jquery.min.js");
require("script!../js/vendors/jquery/jquery-ui.min.js");
require("script!../js/vendors/bootstrap/bootstrap.min.js");
require("script!../js/vendors/metismenu/metisMenu.min.js");
require("script!../js/vendors/nicescroll/jquery.nicescroll.min.js");
require("script!../js/vendors/modal-lightbox/ekko-lightbox.min.js");
require("script!../js/scripts.js");
require('script!../../shared/js/maps.js');


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/js/_shared.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18